import clsx from "clsx";

interface Props {
    className?: string
    FillColor?: string
}

export default function Mail({className, FillColor = 'black'}:Props) {
    return (
        <svg width="24" height="24" className={clsx(className, FillColor)}>
            <path
                d="M20.7107 4.50014C20.7036 4.50005 20.6965 4.5 20.6894 4.5L3.3107 4.5C3.30351 4.5 3.29634 4.50005 3.28919 4.50014H3C2.17157 4.50014 1.5 5.17171 1.5 6.00014V17.2501C1.5 18.4928 2.50736 19.5001 3.75 19.5001H20.25C21.4926 19.5001 22.5 18.4928 22.5 17.2501V6.00014C22.5 5.17171 21.8284 4.50014 21 4.50014H20.7107ZM10.409 15.2197C11.2877 16.0983 12.7123 16.0984 13.591 15.2197L21 7.8107V17.2501C21 17.6644 20.6642 18.0001 20.25 18.0001H3.75C3.33579 18.0001 3 17.6644 3 17.2501V7.81062L10.409 15.2197ZM3.31084 6.00014L20.6892 6.00014L12.5304 14.159C12.2375 14.4519 11.7626 14.4519 11.4697 14.159L3.31084 6.00014Z"/>
        </svg>
    )
}
